import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageLayout, Table, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { useGetChangelogs } from 'src/hooks/changelogs/get-changelogs.hook';

import { StyledSpan, ActionContainer } from './changelog.styles';

const Changelog = () => {
  const { t } = useTranslation(['projects', 'common']);

  const { id } = useParams();

  const { changelogs, paginationConfig } = useGetChangelogs(id as string);

  return (
    <PageLayout pageTitle={t('projects:labels.changelog')}>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('projects:labels.changelog')}
      </Typography>
      <div style={{ marginTop: '24px' }}>
        <Table
          dataSource={changelogs}
          rowKey={record => record._id}
          pagination={paginationConfig}
          t={t}
        >
          <Table.Column
            width={200}
            title={t('projects:labels.timestamp')}
            dataIndex="createdAt"
            key="createdAt"
            render={createdAt => (
              <Typography>{moment(createdAt).format('DD.MM.YYYY HH:mm a')}</Typography>
            )}
          />
          <Table.Column
            title={t('common:labels.action')}
            render={record => {
              const action = t([`projects:changelog.${record.actionType.toLowerCase()}`]);

              const firstActionTarget: string[] = record.relationsObjects
                .map((relation: any, index: number) => {
                  if (index === record.relationsObjects.length - 1) {
                    return null;
                  }
                  if (relation.type === 'FIELD_NAME') {
                    return t(`projects:task.${relation.target}`);
                  }
                  return relation.target;
                })
                .join(' ');

              return (
                <ActionContainer>
                  <Typography>
                    <StyledSpan>{firstActionTarget}</StyledSpan>
                  </Typography>
                  <Typography>{action}</Typography>
                  <Typography>
                    <StyledSpan>
                      {record.relationsObjects[record.relationsObjects.length - 1].target}
                    </StyledSpan>
                  </Typography>
                </ActionContainer>
              );
            }}
          />
          <Table.Column
            width={250}
            title={t('projects:labels.performedBy')}
            dataIndex={['createdByAccount', 'profile', 'displayName']}
            key="displayName"
            render={displayName => <Typography>{displayName}</Typography>}
          />
        </Table>
      </div>
    </PageLayout>
  );
};

export default Changelog;
